import React, { Children, useCallback, useEffect, useMemo, useState } from 'react';
import { Menu, Button } from 'tdesign-react';
import { ViewListIcon, } from 'tdesign-icons-react';
import './index.less';

import type { MenuValue } from 'tdesign-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RouteItemCommonProps } from '@/routes';
import { useGlobalStore } from '@/stores/context';
import { temporaryLogin } from '@/utils';
import { eventBus } from '@/utils/eventBus';

const { SubMenu, MenuItem } = Menu;

type ClosableSideProps = {
  menuList: RouteItemCommonProps[];
}
function ClosableSide(props: ClosableSideProps) {
  const { menuList = [] } = props;
  const [active, setActive] = useState<MenuValue>('');
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isTemporaryLogin = temporaryLogin();
  const {
      state: { userInfo, },
    } = useGlobalStore();
    
  useEffect(() => {
    const { pathname } = location;
    const findItem = (arr: RouteItemCommonProps[]) => {
      let target = '';
      arr.forEach((item) => {
        if (item.path === pathname) {
          target = item.path;
        } else if (item.children) {
          const child = findItem(item.children);
          if (child) {
            target = child;
          }
        }
      });
      return target;
    }
    const v = findItem(menuList);
    if (v) {
      setActive(v);
    } else {
      setActive('/home');
    }
  }, [location.pathname]);

  const handleClick = ({ path }: RouteItemCommonProps) => {
    navigate(path);
    eventBus.emit('menuClick');
  };

  const resources = useMemo(() => {
    if (isTemporaryLogin || !Object.keys(userInfo || {}).length) {
      return [];
    }
    const roleAuthorities = userInfo.userAuthor?.appAuthorities.find(item => item.appId === process.env.APPID)?.roleAuthorities || [];;
    const v = roleAuthorities.find(item => item.resources?.[0]?.appId === process.env.APPID && menuList.some(ele => ele.code === item.resources?.[0]?.code));
    if (v) {
      return v.resources;
    }
    return [];
  }, [userInfo]);

  const checkPermission = useCallback((router: RouteItemCommonProps) => {
    if (isTemporaryLogin) {
      return true;
    }
    if (!Object.keys(userInfo).length) return false;
    return resources.some((item: any) => item.code === router.code);
  }, [userInfo]);

  const render = useCallback((arr: RouteItemCommonProps[]) => {
    if (!Object.keys(userInfo).length && !isTemporaryLogin) return [];
    // process.env.APPID
    return ((menuList: RouteItemCommonProps[]) => {
      return menuList.filter(ele => ele.isInMenu !== false && checkPermission(ele)).map((item, index) => {
        const { children, title, icon, path } = item;
        if (children) {
          return (
            <SubMenu key={index} value={String(index)} title={title} icon={icon}>
              {render(children)}
            </SubMenu>
          );
        }
        return (
          <MenuItem key={index} value={path} icon={icon} onClick={() => handleClick(item)}>
            {title}
          </MenuItem>
        );
      });
    })(arr);
  }, [userInfo]);

  return (
    <Menu
      value={active}
      collapsed={collapsed}
      expandMutex={false}
      theme="dark"
      width="180px"
      operations={
        <Button variant="text" shape="square" icon={<ViewListIcon />} onClick={() => setCollapsed(!collapsed)} />
      }
      className="menu-wrapper"
    >
      {render(menuList)}
    </Menu>
  );
}

export default ClosableSide;
